import * as React from 'react';
import * as Redux from 'react-redux';
import { Grid, Paper } from '@mui/material';
import ListadoDeportes from './components/ListadoDeportes';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import { allDeportesAction, setActivoDeportesAction } from './DeportesAction';
import FormDeportes from './components/FormDeportes';

const DeportesView = () => {
  const dispatch = Redux.useDispatch();

  const deportesStore = Redux.useSelector((state) => state.deportes);

  const [isDelete, setIsDelete] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonComponent
          click={async () => {
            await setActivoDeportesAction(dispatch, null);
            await allDeportesAction(dispatch, deportesStore.params);
          }}
          disabled={deportesStore.loadingAll || deportesStore.all.length === 0}
          white
          refreshIcon
          text={deportesStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
        />
      </Grid>
      <Grid item md={4}>
        <Paper elevation={5} sx={{ pb: 1 }}>
          <FormDeportes isDelete={isDelete} />
        </Paper>
      </Grid>
      <Grid item md={8}>
        <ListadoDeportes
          isDelete={isDelete}
          setIsDelete={(v) => setIsDelete(v)}
        />
      </Grid>
    </Grid>
  );
};

export default DeportesView;
